import { createForOfIteratorHelper as _createForOfIteratorHelper } from '../_virtual/_rollupPluginBabelHelpers.js';
import { getOwnerDocument } from './dom.esm.js';
import { isHTMLElement } from './tabbable.esm.js';

function isInputElement(element) {
  return !!element && isHTMLElement(element) && element.tagName.toLowerCase() === 'input' && 'select' in element;
}
function getActiveElement(element) {
  var doc = element instanceof HTMLElement ? getOwnerDocument(element) : document;
  return doc.activeElement === element;
}
function focus(element) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$isActive = options.isActive,
    isActive = _options$isActive === void 0 ? getActiveElement : _options$isActive,
    _options$nextTick = options.nextTick,
    nextTick = _options$nextTick === void 0 ? true : _options$nextTick,
    preventScroll = options.preventScroll;
  if (isActive(element)) return -1;
  function triggerFocus() {
    if (supportsPreventScroll()) {
      element && element.focus({
        preventScroll: preventScroll
      });
    } else {
      element && element.focus();
      if (preventScroll) {
        var scrollableElements = getScrollableElements(element);
        restoreScrollPosition(scrollableElements);
      }
    }
    if (isInputElement(element)) {
      element.select();
    }
  }
  if (nextTick) {
    return requestAnimationFrame(triggerFocus);
  }
  triggerFocus();
  return -1;
}
var supportsPreventScrollCached = null;
function supportsPreventScroll() {
  if (supportsPreventScrollCached == null) {
    supportsPreventScrollCached = false;
    try {
      var div = document.createElement('div');
      div.focus({
        get preventScroll() {
          supportsPreventScrollCached = true;
          return true;
        }
      });
    } catch (e) {
      // Ignore
    }
  }
  return supportsPreventScrollCached;
}
function getScrollableElements(element) {
  var doc = getOwnerDocument(element);
  var parent = element.parentNode;
  var scrollableElements = [];
  var rootScrollingElement = doc.scrollingElement || doc.documentElement;
  while (parent instanceof HTMLElement && parent !== rootScrollingElement) {
    if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) {
      scrollableElements.push({
        element: parent,
        scrollTop: parent.scrollTop,
        scrollLeft: parent.scrollLeft
      });
    }
    parent = parent.parentNode;
  }
  if (rootScrollingElement instanceof HTMLElement) {
    scrollableElements.push({
      element: rootScrollingElement,
      scrollTop: rootScrollingElement.scrollTop,
      scrollLeft: rootScrollingElement.scrollLeft
    });
  }
  return scrollableElements;
}
function restoreScrollPosition(scrollableElements) {
  var _iterator = _createForOfIteratorHelper(scrollableElements),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _step.value,
        element = _step$value.element,
        scrollTop = _step$value.scrollTop,
        scrollLeft = _step$value.scrollLeft;
      element.scrollTop = scrollTop;
      element.scrollLeft = scrollLeft;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

export { focus };
//# sourceMappingURL=focus.esm.js.map
